import { defineStore } from "pinia";


// import { useUserStore } from "~/store/UserStore";
import nuxtStorage from "nuxt-storage";

export const useCmsStore = defineStore("cms", () => {

  const sliderImages = ref([]);

  // const producTypeImages = ref([]);
  // const searchImages = ref([]);
  const brandImages = ref([]);
  const licenseImages = ref([]);
  const legalDocuments = ref([]);
  const coverSlider = ref([]);
  const keyMoments = ref([]);
  // main cover shows sliding images
  // const cover = ref({});
  // const chainCovers = ref([]);
  const CMSURL = useCMSURLs[CMS_ENV].PATH;
  const accessToken = useCMSURLs[CMS_ENV].PUBLIC_API_TOKEN;

  // const userStore = useUserStore();
  // const cldUser = computed(() => userStore.cldUser);

  const setUpdatedStates = async () => {
    await SetToRedis("cms-nuxt-all", JSON.stringify({
      sliderImages: sliderImages.value,

      // producTypeImages: producTypeImages.value,
      brandImages: brandImages.value,
      // searchImages: searchImages.value,
      licenseImages: licenseImages.value,
      coverSlider: coverSlider.value,
      // cover: cover.value,
      // chainCovers: chainCovers.value,
    }));
  }
  onMounted(() => {
    setTimeout(() => {
      setUpdatedStates().then(() => { console.info("updated cms store") });
    }, 1000 * 20);
  });

  const initFromCache = async () => {
    return true; // TEST ONLY
    const fromCache = await GetFromRedis("cms-nuxt-all");
    if (fromCache.value) {
      const cachedData = JSON.parse(fromCache.value);
      sliderImages.value = cachedData.sliderImages;
      // producTypeImages.value = cachedData.producTypeImages;
      brandImages.value = cachedData.brandImages;
      // searchImages.value = cachedData.searchImages;
      licenseImages.value = cachedData.licenseImages;
      coverSlider.value = cachedData.coverSlider;
      cover.value = cachedData.cover;
      chainCovers.value = cachedData.chainCovers;
      // console.info("initFromCache", cachedData);

    }
    return true;
  }


  //#region HTTP FUNC
  const getCmsHomePage = async (locale) => {
;
    const url = `${useCMSURLs[CMS_ENV].HOME_PAGE}?populate[brand][populate]=image&populate[chain_cover][populate]=image&populate[cover_slider][populate]=image&populate[license][populate]=image&populate[category][populate]=image`; //&locale=en-GB&locale=${locale}`;
    // console.log("url", url);
    const { data, error } = await useFetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer  ${accessToken}`,
      },
    });
    // console.log("error", error.value, data.value);
    return { data };
    // return { data: data.value.data };
  };
  // const getCmsCategory = async () => {
    
  //   const url = `${useCMSURLs[CMS_ENV].HOME_PAGE}?populate[category][populate]=image`; //&locale=en-GB&locale=${locale}`;
  //   // console.log("url", url);
  //   const { data, error } = await useFetch(url, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer  ${accessToken}`,
  //     },
  //   });
  //   const  attributes  = data.value.data;

  //   categoryImages.value = attributes.category.map((x) => ({
  //     image: x.image,
  //     slug: x.slug,
  //     url: x.url,
  //   }));

  // };

  const getCmsBrand = async () => {

    // nuxtStorage.localStorage relies on window/localStorage; guard for SSR.
    if (process.client) {
      try {
        const _brandImages = nuxtStorage.localStorage.getData("BrandCms");
        if (_brandImages) { // TEST ONLY
          brandImages.value = JSON.parse(_brandImages);
          return;
        }
      } catch (e) {
        // Ignore cache read errors and fetch from CMS.
      }
    }
    const url = `${useCMSURLs[CMS_ENV].HOME_PAGE}?populate[brand][populate]=image`; //&locale=en-GB&locale=${locale}`;

    const { data, error } = await useFetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer  ${accessToken}`,
      },
    });
    const  attributes  = data.value.data;

    brandImages.value = attributes.brand.map((x) => ({
      image: x.image,
      slug: x.slug,
      url: x.url,
    }));

  };


  const getCmsSlider = async () => {

    const url = `${useCMSURLs[CMS_ENV].HOME_PAGE}?populate[swiper][populate]=image`; //&locale=en-GB&locale=${locale}`;
    const { data, error } = await useFetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer  ${accessToken}`,
      },
    });
    const attributes  = data.value.data;

    sliderImages.value = attributes.swiper
      .map((x) => ({
        image: x.image,
        slug: x.slug,
        id: x.id,
        url: x.url,
      }))
      .filter((x) => x.image);

  };

  const getCoverSliders = async (selectedLanguage = "en_GB") => {

    const url = `${useCMSURLs[CMS_ENV].HOME_PAGE}?populate[cover_slider][populate]=image`;
    const { data } = await getCmsResource({
      locale: selectedLanguage.replace("_", "-"),
      url: url,
    });

    const  attributes  = data.value.data;
    coverSlider.value = attributes.cover_slider.map((x) => ({
      image: x.image,
      url: x.url,
      slug: x.slug,
    }));

  };
  const getKeyMoments = async (selectedLanguage = "en_GB") => {
    // "Upcoming Key Moments" homepage section (#22). The `key_moments` repeatable
    // component must exist on the Strapi `nuxt-home` single type; until it does,
    // the request fails / returns nothing and the section simply stays hidden.
    try {
      const url = `${useCMSURLs[CMS_ENV].HOME_PAGE}?populate[key_moments][populate]=image`;
      const { data } = await getCmsResource({
        locale: selectedLanguage.replace("_", "-"),
        url: url,
      });

      const attributes = data.value?.data;
      keyMoments.value = (attributes?.key_moments || [])
        .map((x) => ({
          image: x.image,
          title: x.title,
          description: x.description,
          icon: x.icon,
          date: x.date,
          url: x.url,
        }))
        .filter((x) => x.title || x.image);
    } catch (e) {
      keyMoments.value = [];
    }
  };
  const getLicense = async (selectedLanguage = "en_GB") => {
    
    const url = `${useCMSURLs[CMS_ENV].HOME_PAGE}?populate[license][populate]=image`; //&locale=en-GB&locale=${locale}`;
    const { data } = await getCmsResource({
      locale: selectedLanguage.replace("_", "-"),
      url: url,
    });

    const attributes  = data.value.data;
    licenseImages.value = attributes.license.map((x) => ({
      image: x.image,
      url: x.url,
      slug: x.slug,
    }));
  };
  const getCmsResource = async ({ locale, url }) => {
    const { data, error } = await useFetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer  ${accessToken}`,
      },
    });
    return { data };
  };

    const getCmsDocuments = async (locale) => {
       

    const url = `${useCMSURLs[CMS_ENV].DOCUMENTS}?populate[doc][populate]=documents`;

    const { data, error } = await useFetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer  ${accessToken}`,
      },
    });
    if (error.value) {
      console.log("Error fetching CMS documents:", error.value);
      
      return;
    }
    
   const y = data.value.data.doc.map(d=>d.documents);
   legalDocuments.value = y;
    return { data };

  };
const getFileNameFromUrl = (url) => {
  return url.split('/').pop() || 'document.pdf';
};
  const downloadPdf = async (url) => {
  try {
    const fileUrl = getImageUrl(url); // get full path to PDF
    const response = await fetch(fileUrl, {
      mode: 'cors', // if the server supports CORS
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = getFileNameFromUrl(url); // e.g. "CGU.XX.pdf"
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error('Failed to download file:', err);
  }
};
  //#endregion
  const getImageUrl = (url) => `${CMSURL}${url}`;
  return {
   
    getLicense,
    getImageUrl,
    getCoverSliders,
    // getCmsCategory,
    getCmsBrand,
    getCmsSlider,
    sliderImages,
    // searchImages,
    // categoryImages,
    // producTypeImages,
    brandImages,
    // cover,
    initFromCache,
    licenseImages,
    coverSlider,
    keyMoments,
    getKeyMoments,
    getCmsDocuments,
    legalDocuments,
    downloadPdf
  };
}, {
  persist: {
    storage: process.client ? sessionStorage : null,
    beforeRestore: (ctx) => {
      if (process.server) {
        ctx.store.$state = {} // Initialize with empty state on server
      }
    },
    debug: process.dev,
  },
  devtools: true,
});
